import { CaretLeftIcon } from '@radix-ui/react-icons';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useStoreRaccordement } from '../../store/RaccordementStore';
export const DetailRaccordement = () => {
    const { id } = useParams()
    const details = useStoreRaccordement()

    useEffect(() => {
        details.getData(id)
    }, [])

    return (
        <>
            <div className=" mt-10">
                <div className='flex items-center gap-2'>
                    <button className='btn bg-white btn-sm' onClick={() => { window.history.back() }}><CaretLeftIcon /></button>
                    <h1 className="text-2xl lg:text-4xl font-extrabold text-black my-auto">
                        Detail de raccordement
                    </h1>
                </div>

                <div className='bg-white mt-8 p-3 rounded-lg'>
                    <div className="px-4 sm:px-0">
                        <h3 className="lg:text-2xl text-xl font-bold text-gray-900">Information sur le Raccordement</h3>
                    </div>
                    <div className="mt-6 border-t border-gray-100">
                        <dl className="divide-y divide-gray-100">
                            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-bold leading-6 text-gray-900">Date et Heure de debut</dt>
                                <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">{details?.data?.raccordementDetails?.dateDebut}</dd>
                            </div>
                            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-bold leading-6 text-gray-900">Date et Heure de fin</dt>
                                <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">{details?.data?.raccordementDetails?.dateFin}</dd>
                            </div>
                            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-bold leading-6 text-gray-900">Statut du raccordement </dt>
                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{details?.data?.raccordementDetails?.status}</dd>
                            </div>
                            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-bold leading-6 text-gray-900">Résultat du raccordement  </dt>
                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{details?.data?.raccordementDetails?.resultat}</dd>
                            </div>
                            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-bold leading-6 text-gray-900">Commentaire</dt>
                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                    {details?.data?.raccordementDetails?.commentaire}
                                </dd>
                            </div>
                        </dl>
                    </div>
                </div>

                <div className='bg-white mt-8 p-3 rounded-lg'>
                    <div className="px-4 sm:px-0">
                        <h3 className="text-xl lg:text-2xl font-bold text-gray-900">Souscription au forfait initial</h3>
                    </div>
                    <div className="mt-6 border-t border-gray-100">
                        <dl className="divide-y divide-gray-100">

                            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-bold leading-6 text-gray-900">Date et Heure de Souscription</dt>
                                <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">{details?.data?.souscriptionDetails?.date}</dd>
                            </div>
                            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-bold leading-6 text-gray-900">Canal de souscription </dt>
                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{details?.data?.souscriptionDetails?.canal}</dd>
                            </div>
                            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-bold leading-6 text-gray-900">Moyen de paiement </dt>
                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{details?.data?.souscriptionDetails?.moyenPaiement}</dd>
                            </div>
                            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-bold leading-6 text-gray-900">Forfait souscrit </dt>
                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{details?.data?.souscriptionDetails?.forfait?.designation}</dd>
                            </div>
                            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-bold leading-6 text-gray-900">Commentaire</dt>
                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                    {details?.data?.souscriptionDetails?.commentaire}
                                </dd>
                            </div>

                        </dl>
                    </div>
                </div>


                <div className='bg-white mt-8 p-3 rounded-lg'>
                    <div className="px-4 sm:px-0">
                        <h3 className="text-xl lg:text-2xl font-bold text-gray-900">Test de confirmation</h3>
                    </div>
                    <div className="mt-6 border-t border-gray-100">
                        <dl className="divide-y divide-gray-100">
                            {/* <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-bold leading-6 text-gray-900">Représentant du client</dt>
                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">Margot Foster</dd>
                            </div> */}
                            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-bold leading-6 text-gray-900">Date et Heure de confirmation</dt>
                                <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">{details?.data?.testDetails?.date ? new Date(details?.data?.testDetails?.date).toLocaleString() : '--'} </dd>
                            </div>
                            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-bold leading-6 text-gray-900">Statut du test </dt>
                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{details?.data?.testDetails?.resultat}</dd>
                            </div>
                            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-bold leading-6 text-gray-900">Résultat du test  </dt>
                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{details?.data?.testDetails?.resultat}</dd>
                            </div>
                            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-bold leading-6 text-gray-900">Débit constaté </dt>
                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                    {details?.data?.testDetails?.debit}
                                </dd>
                            </div>
                            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-bold leading-6 text-gray-900">Commentaire</dt>
                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                    {details?.data?.testDetails?.commentaire}
                                </dd>
                            </div>

                        </dl>
                    </div>
                </div>

            </div>
        </>
    )
}
